module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_mobirix_m.2a559ace895c5791dfb7e6d7a52b1ae4.png";